function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#50BFA5;}\n\t.st1{fill:#3C8F7C;}\n\t.st2{fill:#355389;}\n\t.st3{fill:#466EB6;}\n\t.st4{fill:#F7CC7F;}\n\t.st5{fill:#FAE0B2;}\n\t.st6{fill:#96D9C9;}\n\t.st7{fill:#F48C7F;}\n\t.st8{fill:#B75742;}\n\t.st9{fill:#86B1F2;}\n\t.st10{fill:#F47458;}\n\t.st11{fill:#184655;}\n\t.st12{fill:#F7A491;}\n\t.st13{fill:#13375B;}\n\t.st14{fill:#CBBBA0;}\n\t.st15{fill:#DF4937;}\n\t.st16{fill:#0593A1;}\n\t.st17{fill:#FDD303;}\n\t.st18{fill:#F89F26;}\n\t.st19{fill:#485678;}\n\t.st20{fill:#00A683;}\n\t.st21{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st22{fill:#3C3C3B;}\n\t.st23{fill:#575756;}\n\t.st24{fill:#FFCB86;}\n\t.st25{fill:#C6C6C6;}\n\t.st26{fill:#F6F6F6;}\n\t.st27{fill:#A48A7B;}\n\t.st28{fill:#E8A246;}\n\t.st29{fill:#7C6255;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_37",
  transform: "translate(-910.191 -428.582)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  className: "st0",
  d: "M973.2,550.7l-2.9,0.9l-2-4.6l-4.4,0.8l-2-3.2l-1.6,1l2.7,4.2l4.2-0.7l2,4.7l4.4-1.4L973.2,550.7z "
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  transform: "translate(1018.553 575.496)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  className: "st0",
  d: "M17,122.8c0,0-15.6-53-16.9-64.7S7.6,50,7.6,50s-7.4-22.3-2-27.6S15.7,27,15.7,27S17.3,0,23,0 c10.6,0,10.4,29.5,10.4,29.5s2.7-11.6,8.4-8.4C50.2,25.9,38,49,38,49s10.9,0,14.7,5.5C59.5,64.4,17,122.8,17,122.8z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5",
  transform: "translate(959.566 613.307)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  className: "st0",
  d: "M81.1,78c0,0-45.1-7.5-54.9-15.5s-0.1-11.6-0.1-11.6S3.5,39.3,3.7,31.4s11.5-3.9,11.5-3.9 S-3.8,5.7,0.7,1.6c8.4-7.7,30.5,14.9,30.5,14.9S24.6,5.8,31.5,4.1c10.4-2.6,18.1,24,18.1,24s-2-10.5,5.2-9.1 C67.7,21.4,81.1,78,81.1,78z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  className: "st1",
  d: "M54.8,18.9c-7.2-1.3-5.2,9.1-5.2,9.1S41.9,1.5,31.5,4c-6.9,1.7-0.3,12.5-0.3,12.5 S9.1-6.1,0.7,1.6L81,78C79.5,70.7,66.9,21.1,54.8,18.9z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  transform: "translate(956.25 660.241)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  className: "st2",
  d: "M97.3,37.3c0,0-23.7-24.1-35.7-26.7s-9.8,6-9.8,6S28-4.1,22.5,0.9s0.4,9.9,0.4,9.9 s-19.8-3.5-22.6,3c-4.3,10,28.1,15.4,28.1,15.4s-13.6,0.9-10.5,7.2C22.9,45.7,97.3,37.3,97.3,37.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  className: "st3",
  d: "M0.4,13.8c2.8-6.5,22.6-3,22.6-3s-6-4.9-0.5-9.9S51,13.8,51,13.8S45.6,3.4,57.5,6 s39.7,31.3,39.7,31.3L0.4,13.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_14",
  transform: "translate(1074.151 435.972)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  className: "st4",
  d: "M17.2,12.5c-5,0.9-8.3,5.6-7.4,10.6c0.4,2.4,1.8,4.5,3.7,5.9c1.2,0.9,2,2.1,2.4,3.5l1.2,4.9 c0.3,1.3,1.6,2.2,3,2l3-0.5c1.4-0.2,2.3-1.5,2.2-2.8c-0.4-5-0.9-6.9,0.7-9.1c3-4.1,2.1-9.8-2-12.8C22,12.8,19.5,12.2,17.2,12.5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  transform: "translate(13.58 18.482)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  className: "st5",
  d: "M4.4,15.4C3.9,11.1,3.1,6.5,2.9,5.2C-1.7,5.5,0,0.6,2.2,2.6c0.6,0.6,0.9,1.3,1.1,2.2 c1.5-0.1,3-0.6,4.4-1.3c-0.3-0.9-0.2-1.7,0-2.6c0.4-1,1.8-1.3,2.3-0.3c0.2,0.4,0.2,0.8,0.1,1.3c-0.4,0.8-1.2,1.5-2,1.9 C8.3,7.2,8.6,10.6,9,14l-0.4,0.1C8.2,10.7,7.9,7.3,7.6,4C6.3,4.6,4.8,5,3.3,5.2c0.3,1.7,1,6.1,1.5,10.1L4.4,15.4z M0.7,4.2 C1.3,4.7,2,4.9,2.8,4.8C2.7,4.1,2.4,3.4,1.9,2.9C0.7,1.9,0,3.5,0.7,4.2z M8.1,1.1C7.9,1.8,7.9,2.5,8,3.3C8.7,3,9.3,2.5,9.7,1.8 c0.2-0.5,0-1.1-0.5-1.3C9.1,0.4,8.3,0.7,8.1,1.1L8.1,1.1z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  className: "st6",
  d: "M15.8,32.4L15.8,32.4l1.2,5c0.3,1.3,1.6,2.2,3,2l3-0.5c1.4-0.2,2.3-1.5,2.2-2.8 c-0.2-2.2-0.4-3.8-0.4-5.1L15.8,32.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  transform: "translate(8.731 3.243)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  className: "st5",
  d: "M2.5,5.7L0.1,1.3c-0.2-0.4,0-1,0.4-1.2S1.4,0,1.6,0.4L4,4.8c0.3,0.4,0.1,1-0.3,1.2 S2.8,6.1,2.5,5.7L2.5,5.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9",
  transform: "translate(0 17.251)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  className: "st5",
  d: "M6,2.2L0.8,1.7C0.3,1.7,0,1.3,0,0.8C0.1,0.3,0.5,0,0.9,0l5.2,0.5C6.6,0.5,7,0.9,7,1.4 C6.9,1.9,6.5,2.2,6,2.2L6,2.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  transform: "translate(0.588 30.622)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  className: "st5",
  d: "M0.3,4.8C0,4.5,0,3.9,0.3,3.6C1.6,2.3,3,1.2,4.5,0.2C4.8-0.1,5.4,0,5.7,0.3 C6,0.7,5.9,1.2,5.5,1.5c0,0,0,0-0.1,0C4,2.5,2.7,3.6,1.5,4.8C1.1,5.1,0.6,5.1,0.3,4.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  transform: "translate(23.45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  className: "st5",
  d: "M0.6,8.7C0.2,8.5-0.1,8.1,0,7.6c0.6-2.2,1-4.5,1.1-6.8C1.1,0.3,1.5,0,2,0s0.8,0.4,0.8,0.9 C2.7,3.3,2.3,5.7,1.7,8C1.6,8.5,1.1,8.8,0.6,8.7L0.6,8.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  transform: "translate(29.424 12.6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  className: "st5",
  d: "M0,2.8c-0.1-0.5,0.1-0.9,0.6-1.1L6,0c0.5-0.1,1,0.2,1.1,0.7c0.1,0.4-0.1,0.9-0.6,1L1.1,3.3 C0.7,3.5,0.2,3.2,0,2.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_13",
  transform: "translate(32.236 25.917)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  className: "st5",
  d: "M6.1,3.8c-0.1,0-0.2,0-0.2,0C4,3.3,2.2,2.6,0.5,1.6C0,1.4-0.1,0.9,0.1,0.4 C0.3,0,0.8-0.1,1.2,0.1c1.6,0.9,3.3,1.5,5.1,2C6.8,2.3,7.1,2.7,7,3.2C6.9,3.6,6.5,3.8,6.1,3.8L6.1,3.8z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  className: "st4",
  d: "M1191.8,504.3l-2.7-6.5l-6.9-1.4c-0.5-0.1-0.9-0.6-0.7-1.1c0-0.2,0.2-0.4,0.3-0.5l5.3-4.6l-0.8-7 c-0.1-0.5,0.3-1,0.9-1.1c0.2,0,0.4,0,0.6,0.1l6,3.6l6.4-2.9c0.5-0.2,1.1,0,1.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6l-1.6,6.8l4.7,5.2 c0.4,0.4,0.3,1-0.1,1.4c-0.2,0.1-0.4,0.2-0.6,0.2l-7,0.6l-3.5,6.1c-0.3,0.5-0.9,0.6-1.3,0.4 C1192.1,504.6,1191.9,504.5,1191.8,504.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  className: "st7",
  d: "M1235.3,482.1l-1.1,4.5l-7.5-1l-2.5,6.4l-5.7,0.2l0.1,2.9l7.6-0.2l2.3-6.1l7.8,1l1.7-6.8 L1235.3,482.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  className: "st8",
  d: "M1168.7,698.9h-131.4c-5.1-0.1-9.2-4.3-9.1-9.4v-5.6c-0.1-5.1,4-9.3,9.1-9.4h131.4 c-6,6.9-6.1,17.2-0.2,24.2L1168.7,698.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  className: "st5",
  d: "M1166.7,677.2h-72.9c-5.1,0.1-9.2,4.3-9.1,9.4l0,0c-0.1,5.1,4,9.3,9.1,9.4h72.9 C1163.3,690.3,1163.3,683.1,1166.7,677.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  className: "st9",
  d: "M1122.5,657.5c0.1-0.3,0-0.6-0.3-0.7c-0.1,0-0.2-0.1-0.3,0h-69.5c-5.5,0-9.9,4-9.9,8.9l0,0 c0,4.9,4.4,8.9,9.9,8.9h69.6c0.3,0,0.6-0.2,0.6-0.5c0-0.1,0-0.2,0-0.3l0,0C1119.8,668.6,1119.8,662.5,1122.5,657.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  className: "st4",
  d: "M1122.1,658.3h-34.5c-6.4,0-11.6,3.3-11.6,7.4s5.2,7.4,11.6,7.4h34.7 C1120,668.6,1119.9,663.1,1122.1,658.3z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_15",
  transform: "translate(1106.954 661.863)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  className: "st8",
  d: "M6.2,0H1.7C0.8,0,0,0.3,0,0.7v0.1h6.2V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  className: "st10",
  d: "M10.1,1.8c0-1-1.2-1.8-2.6-1.8H1.7c1.1,0,2,0.6,2,1.4v19.5l3.2-2.5l3.2,2.5V1.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_17",
  transform: "translate(1038.012 639.819)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  className: "st5",
  d: "M71.7,16.2H31.3c-3.6,0-6.5-3.5-6.5-7.7l0,0c0-4.3,2.9-7.7,6.5-7.7h40.5 c-3.1,4.5-3.2,10.4-0.3,15L71.7,16.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  className: "st3",
  d: "M24.8,8.5L24.8,8.5c0-4.3,3-7.7,6.7-7.7h41.1c0.2,0,0.4-0.2,0.3-0.4l0,0c0-0.2-0.1-0.4-0.3-0.4 H7.3C3.3,0,0,3.8,0,8.5l0,0C0,13.2,3.3,17,7.3,17h65.2c0.2,0,0.4-0.2,0.3-0.4l0,0c0-0.2-0.1-0.4-0.3-0.4H31.4 C27.8,16.2,24.8,12.8,24.8,8.5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_16",
  transform: "translate(58.431 4.589)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  className: "st11",
  d: "M6.2,0H1.7C0.8,0,0,0.3,0,0.7v0.1h6.2V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  className: "st1",
  d: "M10.1,1.8c0-1-1.2-1.8-2.6-1.8H1.7c1.1,0,2,0.6,2,1.3v19.1L6.8,18l3.2,2.5L10.1,1.8z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  transform: "translate(1047.575 481.654)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19",
  transform: "translate(74.123 43.275)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  className: "st11",
  d: "M52.5,1.6l6-1.6l-4,54l-7.2,0.2l3.6-50.7C51,2.6,51.6,1.8,52.5,1.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_18"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  className: "st4",
  d: "M55,55.6c-0.1,0-0.3,0-0.4,0c-1.2-0.2-2.1-1.4-2-2.6l4-50.8c0-1.2,1-2.2,2.2-2.1h0.1 c1.2,0.2,2.1,1.4,2,2.6l-4,50.8C56.9,54.5,56.1,55.4,55,55.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  className: "st4",
  d: "M0,58.3L0,58.3L0,58.3c0,2,1.6,3.6,3.6,3.6L54,57.3c1.9-0.3,3.2-2.1,2.9-4c0-0.1,0-0.2,0-0.3 L0,58.3z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  className: "st12",
  d: "M109.3,156.1c-3.3,1.8-13.4-1.4-13.4-1.7c-0.1,2.8-11.3,29.8-11.3,29.8v8.3 c0,0,23,1.1,22.7-0.9s-1.6-0.7-6.2-4.5c-0.4-0.3-6.8-1.8-5.1-5.6C99.5,173.7,106.9,160.9,109.3,156.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  className: "st1",
  d: "M83.8,192.8H109c0.9-0.1,1.1-0.8,0.8-1.3c-0.7-0.9-5.5-3.1-8.7-4.6c-5.6,0.7-15.6-1.5-16.5-2.8 C82.2,187.4,83.3,192.7,83.8,192.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  className: "st2",
  d: "M78.3,136.7c-0.3-1,21.7-10.4,22.7-9.3c1.7,1.9-11.9,37.3-11.9,37.3l15.7,4.8 c0,0,16.3-40.9,15.6-48.4s-8.9-16-26.6-10.6S78.3,136.7,78.3,136.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_41",
  className: "st12",
  d: "M123.9,160.7c-4.1-0.6-8.2-0.9-12.4-0.9c0.5,3.4,2.7,21,2.3,22.1c-1,2.7-2.9,4.9-5.3,6.4 c0,0,17.1,15.4,18.1,13.6s-0.8-1.5-1.9-7.4c-0.1-0.5-2.6-8.7-2.7-13.2C121.7,173,123.7,165.4,123.9,160.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_42",
  className: "st3",
  d: "M118.4,103.1c-2.4-1.3-8.6-1.3-15.4-0.9c-13.3,0.9-26.4,3.5-39,7.7l-8.4,2.8V104 c0,0-26.9-4.5-27.8,2.2c-1.4,10,0.3,30.4,9.3,34.9c27.8,14.1,66.8-22.5,66.9-17.7c0.2,6.4,5.6,30.4,7,40.9 c3.9,0.1,10.5,0.1,13.4-0.6C124.9,143.2,125.2,106.8,118.4,103.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  className: "st1",
  d: "M108,188.7l19.2,15.4c0.8,0.5,1.4,0.1,1.4-0.5c0.1-1.1-2.3-5.9-3.9-9.1 c-4.8-3.1-11.1-11.1-11-12.6C111.7,183.6,107.6,188.3,108,188.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  className: "st13",
  d: "M64.4,19.4c-0.6-5.9-1.3-11.8-6.2-16.1c-4-3.5-9-4.1-14-2.2c-14.1,5.3-6.8,17.8-24.8,30.5 c-5.6,3.9-11.7,6.6-16,11.9c-5.9,7.4-3.7,16.3,1.7,22.2c25.7,28.4,54.3-10,56.4-19.2C63.1,39.6,64.9,23.2,64.4,19.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  className: "st0",
  d: "M59.2,52.6c-1.3-2.4-2.7-4.7-4.3-6.9c-2.2-3.9-7.8-5.8-7.8-5.8s-1.9,0-4,0.1 c-0.1,0.3-0.2,0.5-0.4,0.7c-0.8,0.6-5.5-0.2-8.5,1.9c-10,8.6-7.2,50.4-6.4,63.6l30.7,0.3c0,0-3.9-28.4,2.4-35.7 C65.1,65.7,62.3,58.3,59.2,52.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  className: "st12",
  d: "M45.4,25.7c0,0-1.7,12-2.9,15s6.5,9.2,12.8,11.1s-1.9-6.5-1.7-9.6S55,24.3,55,24.3L45.4,25.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_47",
  className: "st10",
  d: "M54.8,28.5c0.2-2.4,0.3-4.2,0.3-4.2l-9.7,1.5c0,0-0.2,1.4-0.5,3.4 C48.8,31.4,52.4,30.7,54.8,28.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_48",
  className: "st12",
  d: "M48.5,3.7C46,4.4,43.8,6,42.3,8.2c-2.4,3.6-4,14.2,3.8,19.2s13.8-2.1,13.9-8.9 S58.6,2.5,48.5,3.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  className: "st12",
  d: "M61.8,16.3c-0.7,1.7-2,2.7-2.9,2.3s-1.2-2-0.5-3.7s2-2.7,2.9-2.3S62.5,14.7,61.8,16.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  className: "st13",
  d: "M49.6,3.5c0,0-4.9,10.9-9.2,11.9s-4.2,6.5-4.2,6.5s0.1-12.7,4.1-15.6 C43.1,4.4,46.3,3.5,49.6,3.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  className: "st12",
  d: "M42.1,17.7c0.6,1.8,0,3.5-1.2,3.9s-2.6-0.8-3.2-2.5s0-3.5,1.2-3.9S41.6,15.9,42.1,17.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  className: "st12",
  d: "M97,96.7c-1.8-0.7-4.6-0.7-4.5-1c0.2-1,8.3,2.2,7.2,0.7c-0.6-0.8-6.7-3.6-8.2-3.2 c-1.4,0.5-10.9,3.1-10.9,3.1l-25.7-6c0,0-6.5-14.8-7.1-27.4c-4.8,0.6-9.5,2.2-13.7,4.6c2.3,12.1,7.7,31.8,13.8,35.5 c2.5,1.6,32.9-1.9,32.9-1.9s6.7-0.5,7.8-0.9c0.8-0.3,3-1.5,4.1-1.9c2.6-0.7,7.3,1.1,7.4,0.6C100,98.7,98.9,97.4,97,96.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  className: "st6",
  d: "M47.9,49.4c-0.2-3.9-1.7-7.7-5.9-8.9c-2.6-0.7-5.4-0.1-7.5,1.6c-2.4,2-3.1,5.2-3.1,8.2 c0,7,0.6,13.9,1.8,20.8c4.8-2.6,10.1-4.2,15.5-4.9C48.7,66.3,48.3,54.5,47.9,49.4z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_21",
  transform: "translate(974.518 498.425)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  className: "st4 pulsate",
  d: "M41.2,40L1.3,32.5c-0.8-0.1-1.3-0.9-1.2-1.7L5.2,4c0.1-0.8,0.9-1.3,1.7-1.2l39.9,7.4 c0.8,0.1,1.3,0.9,1.2,1.7l-5,26.8C42.8,39.6,42,40.1,41.2,40z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  className: "st4 pulsate",
  d: "M22.2,9.3L10.1,7C9.3,6.9,8.8,6.1,8.9,5.3l0.8-4.1c0.1-0.8,0.9-1.3,1.7-1.2l12.1,2.3 c0.8,0.1,1.3,0.9,1.2,1.7L24,8.1C23.8,8.9,23.1,9.4,22.2,9.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  className: "st5 pulsate",
  d: "M43.1,38.9c-0.2,0.7-0.9,1.2-1.7,1L1.2,32.5c-0.7-0.1-1.3-0.8-1.2-1.6l2.1-24 C2.2,6,2.9,5.4,3.7,5.5h0.1l44.6,8.3c0.8,0.1,1.3,0.9,1.2,1.7v0.1L43.1,38.9z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_22",
  transform: "translate(1192.286 442.628)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  className: "st0",
  d: "M8.3,6.8L1.5,8.7L0,0.4L2.2,0l1,5.8l4.4-1.2L8.3,6.8z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  className: "st10",
  d: "M1134,623.3h-103.5c-3.2,0-5.8,2.6-5.8,5.8l0,0v4.9c0,3.2,2.6,5.8,5.8,5.8l0,0H1134l-0.1-0.1 C1129.5,635.2,1129.5,627.9,1134,623.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  className: "st5",
  d: "M1132.1,625.7h-55.3c-3.2,0-5.8,2.6-5.8,5.8l0,0l0,0c0,3.2,2.6,5.8,5.8,5.8l0,0h55.3 C1130.1,633.8,1130.1,629.3,1132.1,625.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_30",
  transform: "translate(1210.726 590.165)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_28",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  className: "st5",
  d: "M5.8-50.5l-7.9-19.7c-0.4-1,0.1-2.1,1.1-2.5L27.3-84c1-0.4,2.1,0.1,2.5,1.1l7.8,19.7 c0.4,1-0.1,2.1-1.1,2.5l0,0L8.3-49.4C7.3-49,6.2-49.5,5.8-50.5L5.8-50.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  className: "st3",
  d: "M32.4-61.9l-7-17.7c-0.1-0.3,0-0.6,0.3-0.7l0,0l0,0c0.3-0.1,0.6,0,0.7,0.3l0,0l7.1,17.7 c0.1,0.3,0,0.6-0.3,0.7l0,0l0,0C32.9-61.5,32.5-61.6,32.4-61.9L32.4-61.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  className: "st3",
  d: "M29.1-64.2l-5.8-14.6c-0.1-0.3,0-0.6,0.3-0.7l0,0l0,0c0.3-0.1,0.6,0,0.7,0.3l0,0l5.8,14.5 c0.1,0.3,0,0.6-0.3,0.7l0,0l0,0C29.5-63.8,29.2-63.9,29.1-64.2L29.1-64.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  className: "st3",
  d: "M28.2-60.2l-7-17.7c-0.1-0.3,0-0.6,0.3-0.7l0,0l0,0c0.3-0.1,0.6,0,0.7,0.3l0,0l7.1,17.7 c0.1,0.3,0,0.6-0.3,0.7l0,0l0,0C28.7-59.8,28.3-59.9,28.2-60.2L28.2-60.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  className: "st3",
  d: "M24.5-63.4l-5.4-13.7c-0.1-0.3,0-0.6,0.3-0.7l0,0l0,0c0.3-0.1,0.6,0,0.7,0.3l0,0l5.4,13.7 c0.1,0.3,0,0.6-0.3,0.7l0,0l0,0C25-63,24.6-63.1,24.5-63.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  transform: "translate(31.149 2.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  className: "st2",
  d: "M1.1-83.6l-0.2-0.3c0-0.2-0.1-0.2-0.3-0.2L-2.1-83c-0.1,0-0.1,0.2-0.1,0.3l0.1,0.4 c0,0.1,0.2,0.2,0.3,0.1l2.7-1.1C1.1-83.3,1.1-83.5,1.1-83.6L1.1-83.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  className: "st2",
  d: "M1.7-82.1l-0.1-0.3c0-0.1-0.2-0.2-0.3-0.1l-2.7,1c-0.2,0.1-0.2,0.2-0.2,0.3l0,0l0.1,0.4 c0,0.1,0.2,0.2,0.3,0.1l0,0l2.7-1.1C1.7-81.8,1.8-81.9,1.7-82.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  className: "st2",
  d: "M2.3-80.5l-0.1-0.4C2.1-81,2-81.1,1.8-81l0,0l-2.6,1C-1-79.9-1-79.8-1-79.6l0.1,0.4 c0.1,0,0.3,0.1,0.4,0.1l2.7-1.1C2.3-80.3,2.4-80.4,2.3-80.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  className: "st2",
  d: "M2.9-79l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.1l-2.7,1.1c-0.2,0-0.2,0.2-0.2,0.3l0.2,0.3 c0,0.1,0.2,0.2,0.3,0.1l0,0l2.7-1C2.9-78.7,3-78.9,2.9-79L2.9-79z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  className: "st2",
  d: "M3.5-77.5l-0.1-0.3c0-0.1-0.2-0.2-0.3-0.1l0,0l-2.7,1c-0.1,0-0.2,0.2-0.2,0.3l0.1,0.4 c0.1,0.1,0.3,0.2,0.4,0.1l0,0l2.7-1.1C3.5-77.2,3.6-77.4,3.5-77.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  className: "st2",
  d: "M4.1-76L4-76.3c0-0.1-0.2-0.2-0.3-0.1l-2.7,1c-0.1,0.1-0.2,0.2-0.1,0.3L1-74.7 c0,0.1,0.2,0.2,0.3,0.1l0,0L4-75.7C4.1-75.7,4.2-75.8,4.1-76z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  className: "st2",
  d: "M4.7-74.4l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.1l0,0l-2.7,1.1c-0.1,0.1-0.2,0.2-0.1,0.3l0,0l0.1,0.4 c0,0.1,0.2,0.2,0.3,0.1l0,0l2.7-1.1C4.7-74.2,4.8-74.3,4.7-74.4L4.7-74.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  className: "st2",
  d: "M5.3-72.9l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.1l0,0l-2.7,1.1C2.1-72.2,2-72.1,2.1-72l0.1,0.4 c0,0.1,0.2,0.2,0.3,0.1l0,0l2.7-1.1C5.3-72.6,5.4-72.8,5.3-72.9L5.3-72.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  className: "st2",
  d: "M5.9-71.4l-0.1-0.3c0-0.1-0.2-0.2-0.3-0.1l-2.7,1c-0.1,0.1-0.2,0.2-0.1,0.3l0.1,0.4 C2.8-70,3-69.9,3.1-70l0,0l2.7-1.1C5.9-71.1,6-71.3,5.9-71.4L5.9-71.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  className: "st2",
  d: "M6.6-69.9l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.1l-2.7,1.1c-0.1,0.1-0.2,0.2-0.1,0.3l0.1,0.4 c0,0.1,0.2,0.2,0.3,0.1l0,0l2.7-1.1C6.6-69.6,6.6-69.7,6.6-69.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  className: "st2",
  d: "M7.2-68.3l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.1l0,0l-2.7,1.1C4-67.6,3.9-67.5,4-67.4v0.3 C4-67,4.2-66.9,4.3-67L7-68.1C7.2-68.1,7.2-68.2,7.2-68.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  className: "st2",
  d: "M7.8-66.8l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.1l0,0l-2.7,1.1c-0.1,0.1-0.2,0.2-0.1,0.3l0.1,0.4 c0,0.1,0.2,0.2,0.3,0.1l0,0l2.7-1.1C7.8-66.5,7.8-66.7,7.8-66.8z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  transform: "translate(36.092 17.635)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  className: "st8",
  d: "M10.2-83.9L-1-67.9c0,0,0,0.1-0.1,0.1l-1.1,3.5c-0.1,0.2,0.1,0.5,0.3,0.6c0.1,0,0.3,0,0.4-0.1 l3-2.3l0.1-0.1l11.2-16c0.1-0.2,0.1-0.5-0.1-0.6l0,0L10.8-84C10.6-84.2,10.4-84.1,10.2-83.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  className: "st4",
  d: "M1.6-66.2L1.6-66.2L-1.3-64l-0.8-0.5l1.1-3.3C-0.1-67.4,0.8-66.8,1.6-66.2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_33",
  transform: "translate(1198.627 639.957)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  className: "st3 swing",
  d: "M23.8-22.7l2.7-2.9c6.6-6.9,14.3-12.5,22.9-16.5l0.9-0.4c0,0,0.7-7.6-6.2-8.7l0,0 C36.8-44.6,28.5-39,19.7-34.5l-3.2,1.4L23.8-22.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  className: "st9 swing",
  d: "M16.4-33.1c0.6-0.4,2.6,1.6,4.6,4.5s3.3,5.6,2.8,6s-2.6-1.7-4.6-4.6S15.9-32.8,16.4-33.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  className: "st2 swing",
  d: "M16.4-33.1L16.4-33.1c0,0,4.9,5.8,5.4,8.2l1-0.7c-0.5-1.1-1.1-2-1.8-3 C19.1-31.4,17-33.5,16.4-33.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_32",
  transform: "translate(3.509 14.386)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  className: "st8 swing",
  d: "M27.1-55.3c0.8,0,4.5,0.3,6,6.4c0.5-0.4,1.1-0.8,1.6-1.2c-1.1-3.8-3.1-5.6-4.6-6.3 c-0.2-0.1-0.6-0.3-0.8-0.4C28.6-56.3,27.9-55.8,27.1-55.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  className: "st8 swing",
  d: "M32-49.4l-0.3,8.9l1.8-2.1l2.3,1.2l-2.2-8.5L32-49.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  className: "st8 swing",
  d: "M34.1-50.3l5.5,3.2l-0.8-2.2l1.8-0.9l-5.8-1.5L34.1-50.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  className: "st10 swing",
  d: "M35.6-51.5c0.2,1.6-1,3.1-2.6,3.2c-1.6,0.2-3.1-1-3.2-2.6c-0.2-1.6,1-3.1,2.6-3.2h0.1 C34.1-54.2,35.5-53.1,35.6-51.5z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_99",
  className: "st4",
  d: "M970,463.5l1.9,3.8l4.4-0.1l1.9,4.5l4.6-1.6l2.3,5l4.4-0.9l3,4.4l-1.7,1.1l-2.3-3.3l-4.7,1 l-2.3-4.8l-4.7,1.6l-2.1-4.9l-4.3,0.1l-1.8-3.6l-2.8,0.7l-0.5-2L970,463.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  className: "st0",
  d: "M1220.8,563.4l4,1.6l3.2-3l4.3,2.1l2.4-4.2l5,2.2l2.7-3.6l5.2,1.3l-0.5,2l-3.9-1l-2.9,3.8 l-4.8-2.1l-2.5,4.3l-4.8-2.4l-3.1,2.9l-3.7-1.5l-1.7,2.4l-1.7-1.2L1220.8,563.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M1023.7,451.2c-9.4,9.4-12.5,30.9-1.9,31.8c11.3,1,8.8-10.8,15.8-10.3c5.2,0.4,4.6,7.3,11.2,4.8 c8-2.9,13.4-20.3,6.3-28.4C1046.6,439.5,1033.1,441.9,1023.7,451.2z M1051.9,470.1c-1.3,2.5-4,3.6-6.1,2.6 c-2.1-1.1-2.7-3.9-1.4-6.4c1.3-2.5,4-3.6,6.1-2.6S1053.2,467.6,1051.9,470.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M1024.3,473.6c1.3,1.3,1.3,3.5,0,4.9c-1.3,1.3-3.5,1.3-4.9,0c-1.3-1.3-1.3-3.5,0-4.9 C1020.8,472.3,1023,472.3,1024.3,473.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M1024.1,463.1c1.3,1.3,1.3,3.5,0,4.9c-1.3,1.3-3.5,1.3-4.9,0c-1.3-1.3-1.3-3.5,0-4.9 C1020.5,461.7,1022.7,461.7,1024.1,463.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M1029.6,453.4c1.3,1.3,1.3,3.5,0,4.9c-1.3,1.3-3.5,1.3-4.9,0c-1.3-1.3-1.3-3.5,0-4.9 C1026.1,452.1,1028.3,452.1,1029.6,453.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M1038.2,447.3c1.3,1.3,1.3,3.5,0,4.9c-1.3,1.3-3.5,1.3-4.9,0c-1.3-1.3-1.3-3.5,0-4.9 S1036.9,446,1038.2,447.3z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 1046.1,
  cy: 449.2,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st20",
  cx: 1052.9,
  cy: 457.3,
  r: 3.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M1052.3,459.6c-1.4-0.8-1.8-2.7-1-4c0.3-0.5,0.8-0.9,1.3-1.1c-0.9,0.1-1.8,0.5-2.3,1.4c-0.8,1.4-0.4,3.2,1,4 c0.9,0.5,1.9,0.6,2.7,0.2C1053.4,460,1052.8,459.9,1052.3,459.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M1045.8,451.4c-1.4-0.8-1.8-2.7-1-4c0.3-0.5,0.8-0.9,1.3-1.1c-0.9,0-1.8,0.5-2.3,1.4c-0.8,1.4-0.4,3.2,1,4 c0.9,0.5,1.9,0.6,2.7,0.2C1046.9,451.9,1046.3,451.8,1045.8,451.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M1035.2,451.9c-1.4-0.8-1.8-2.7-1-4c0.3-0.5,0.8-0.9,1.3-1.1c-0.9,0.1-1.8,0.5-2.3,1.4c-0.8,1.4-0.4,3.2,1,4 c0.9,0.5,1.9,0.6,2.7,0.2C1036.3,452.3,1035.7,452.2,1035.2,451.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M1026.9,458c-1.4-0.8-1.8-2.7-1-4c0.3-0.5,0.8-0.9,1.3-1.1c-0.9,0.1-1.8,0.5-2.3,1.4c-0.8,1.4-0.4,3.2,1,4 c0.9,0.5,1.9,0.6,2.7,0.2C1028,458.5,1027.5,458.3,1026.9,458z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M1021.3,467.7c-1.4-0.8-1.8-2.7-1-4c0.3-0.5,0.8-0.9,1.3-1.1c-0.9,0-1.8,0.5-2.3,1.4c-0.8,1.4-0.4,3.2,1,4 c0.9,0.5,1.9,0.6,2.7,0.2C1022.5,468.2,1021.9,468,1021.3,467.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M1021.6,478.2c-1.4-0.8-1.8-2.7-1-4c0.3-0.5,0.8-0.9,1.3-1.1c-0.9,0.1-1.8,0.5-2.3,1.4c-0.8,1.4-0.4,3.2,1,4 c0.9,0.5,1.9,0.6,2.7,0.2C1022.7,478.7,1022.2,478.5,1021.6,478.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M1034.1,439.7c-1.4-0.3-2.5-1.3-3.1-2.6c-0.6-1.3-0.8-2.7-0.7-4.1c0-0.5,0.1-0.9,0.1-1.4 c-0.1-1.2-0.9-2.3-2-2.7c1-0.2,2.1,0.2,3,0.8c0.9,0.6,1.6,1.4,2.2,2.2c0.9,1.1,1.7,2.3,2.1,3.6c0.4,1.4,0.1,3-0.9,3.9 c-0.1,0.1-0.2,0.2-0.3,0.2C1034.4,439.7,1034.2,439.7,1034.1,439.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M1033.7,438.6c0,0-0.1-0.1-0.3-0.2c-0.2-0.1-0.5-0.3-0.8-0.6c-0.1-0.2-0.3-0.3-0.4-0.5s-0.3-0.4-0.4-0.7 c-0.1-0.2-0.2-0.5-0.3-0.8c-0.1-0.3-0.1-0.5-0.2-0.8c-0.1-1.1,0-2.2-0.1-3c0-0.2,0-0.4-0.1-0.5c0-0.2-0.1-0.3-0.2-0.4 c0-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c0,0,0,0,0.1,0c0,0,0.2,0,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.1,0.3,0.2,0.5 c0.2,0.8,0.1,1.9,0.3,2.9c0,0.3,0.1,0.5,0.1,0.8s0.1,0.5,0.2,0.7s0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.4,0.3,0.5 c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.2,0.3,0.3C1033.6,438.5,1033.7,438.6,1033.7,438.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M1032.2,431.8c0,0,0.1,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.2,0.5 c0.1,0.7,0.1,1.7,0.2,2.6c0,0.2,0.1,0.5,0.1,0.7c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.4,0.3,0.8,0.5,1.1c0.2,0.3,0.4,0.5,0.5,0.7 s0.2,0.3,0.2,0.3s-0.1-0.1-0.3-0.2c-0.2-0.1-0.4-0.3-0.7-0.6c-0.2-0.3-0.5-0.6-0.7-1.1c-0.1-0.2-0.2-0.4-0.2-0.7 c0-0.2-0.1-0.5-0.1-0.7c-0.1-1,0.1-2,0-2.6c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.2-0.1-0.3C1032.3,431.9,1032.2,431.8,1032.2,431.8z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M1033.7,433.8c0,0,0,0.1,0.1,0.2c0,0.1,0.1,0.3,0.2,0.5c0.2,0.4,0.6,0.8,0.8,1.4c0.1,0.1,0.1,0.3,0.2,0.5 c0,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.3,0,0.4s0,0.3-0.1,0.4c-0.2,0.5-0.4,0.7-0.4,0.7s0-0.1,0.1-0.2s0.1-0.3,0.1-0.5 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.2-0.5-0.4-0.8 c-0.1-0.3-0.2-0.5-0.3-0.7c-0.1-0.2-0.1-0.4-0.1-0.6C1033.7,433.9,1033.7,433.8,1033.7,433.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M1053.2,481.2l-15-29.4c-0.3-0.5,0-1,0.5-1.3l2.2-1.1c0.5-0.3,1,0,1.2,0.6l13,30.2c0.2,0.5,0,1-0.4,1.3 l0,0C1054.1,481.9,1053.5,481.7,1053.2,481.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M1038.4,452.4l-5.2-13.1c1,0.3,2.1-0.3,2.5-1.2l6.8,12.5C1042.7,451.9,1039.4,453.8,1038.4,452.4z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M1034.6,439.8c-0.3,0.1-0.6,0.2-0.9,0.1l5,12.3c0.5,0.4,1.1,0.4,1.7,0.1L1034.6,439.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M1020.6,437l4,4.8c-0.3,0.7-0.8,1.1-1.5,1.4l-4.4-4.5L1020.6,437z"
}), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M1032.3,450.3c0.3-0.3,0.7-0.2,1,0.1l28,31.7c0.4,0.5,0.5,1.2,0.2,1.6l0,0c-0.4,0.5-1.2,0.3-1.7-0.2 l-28.9-31c-0.3-0.3-0.2-0.7,0.1-1L1032.3,450.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M1032.3,450.3c0.3-0.3,0.7-0.2,1,0.1l28,31.7c0.4,0.5,0.5,1.2,0.2,1.6l0,0c-0.4,0.5-1.2,0.3-1.7-0.2 l-28.9-31c-0.3-0.3-0.2-0.7,0.1-1L1032.3,450.3z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_3_"
}, /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M1024.7,441.8l9.4,9.3c0.3,0.8-1.5,3-2.5,2.2l-8.3-10.1C1023.7,442.9,1024.3,442.3,1024.7,441.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M1024.1,443c-0.2,0.2-0.3,0.3-0.5,0.3l8,9.5c0.5,0.2,0.8,0,1.1-0.4L1024.1,443z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M1022.9,442c0,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.3c-0.5-0.3-0.9-1-1.6-1.5c-0.6-0.6-1.2-1-1.6-1.5 c0,0,0,0,0-0.1l0.2-0.1c0,0,0,0,0.1,0c0.4,0.4,1.1,0.7,1.7,1.3c0.7,0.6,1,1.3,1.4,1.7c0.2,0.2,0.4,0.3,0.5,0.4 C1022.8,441.9,1022.9,441.9,1022.9,442z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M1021.9,439.9c0.1,0.3,0.2,0.5,0.3,0.7s0.2,0.3,0.3,0.4s0.1,0.1,0.1,0.1s-0.1,0-0.2-0.1 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.6-0.9-1-1.3c-0.5-0.4-1-0.7-1.4-1c-0.1-0.1-0.2-0.2-0.2-0.2l0.1-0.1c0.1,0,0.2,0.1,0.2,0.1 c0.4,0.2,1,0.4,1.5,0.9C1021.6,439.3,1021.8,439.6,1021.9,439.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M1022.1,438.9c0.1,0.2,0.3,0.3,0.3,0.5c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0.3,0.2,0.6,0.4,0.8 c0.1,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.1,0.1,0.2,0.1c-0.1,0-0.4-0.1-0.7-0.4c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.1-0.2-0.3-0.3-0.4 s-0.2-0.3-0.3-0.4c-0.5-0.5-1-1-1.4-1.4l-0.3-0.3l0.1-0.1c0.1,0.1,0.2,0.1,0.4,0.2C1021,438,1021.6,438.3,1022.1,438.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M1051.8,464.8c1,1.4,1.1,3.4,0.1,5.3c-1.3,2.5-4,3.6-6.1,2.6c-0.4-0.2-0.8-0.5-1.1-0.9l-3.2,3.2 c1.7,1.9,3,4.2,7.3,2.6c5.6-2,10-11.3,9.5-19.4L1051.8,464.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_31",
  transform: "translate(1135.581 432.468)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_87",
  className: "st3 shake",
  d: "M3.4,12.2c1.6,1.3,4.4,5.4,8,8.3c2.1,1.7,3.7,1.3,6.4,1.6c12.7,1.5,9.2,4.1,10.8,4.4 c-0.4,1-4.4,9.4-5.1,11.1c-0.5,1.5-2,2.3-3.6,2c-2.6-0.4-5.3-0.6-7.9-1.2C5.4,37,1.7,33.7-3,29.7c-1.2-0.9-1.6-2.6-0.9-3.9 C-1.8,21.1,0.7,16.5,3.4,12.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_88",
  className: "st9 shake",
  d: "M30,36.6c-0.1,2.8,0.2,3.3-1,2.9c-0.7-0.3-1.4-0.6-2.1-0.9c-0.5-0.2-0.5-0.6-0.1-1 c0.6-0.6,1.1-1.1,1.7-1.7c-0.4-1.1,0.1-2.3,1.1-2.9c0.2-0.1,0.1,0.1,1.8-3.9c-5.8-0.7-10-1.2-17.1-2.1c-1.9-0.2-3.6-1-5.1-2.2 C4.1,20.5-1,16.3-6.1,12c-0.6-0.5-0.8-1.3-0.3-2c0,0,0.1-0.1,0.1-0.1c0.4-0.4,1-0.6,1.6-0.4c1.6,0.2,17.6,2.2,19.2,2.4 c2.1,0.2,4,1.1,5.6,2.4c5,4.2,10,8.4,15,12.5c0.7,0.6,0.9,1.1,0.6,1.7c-0.2,0.7-1,1.1-1.7,0.9c0,0,0,0,0,0 c-0.6-0.1-0.9,0.1-1.1,0.6c-1,2.6-1.7,3.2-1.4,4.2C31.5,35.3,30.9,36.2,30,36.6z"
})));

function SvgStudent2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 270.3",
    style: {
      enableBackground: "new 0 0 375 270.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent2);
export default __webpack_public_path__ + "static/media/student_2.89033501.svg";
export { ForwardRef as ReactComponent };